import blockOrigin from 'bem-cn-lite';
export var NAMESPACE = 'ic-';
export function block(name) {
  return blockOrigin("".concat(NAMESPACE).concat(name));
}
// #sourceMappingURL=cn.js.map